module.exports = __webpack_public_path__ + "img/question_delete.f614b0c9.svg";